import React from 'react';
import cn from 'classnames';

import styles from './icon.module.scss';

interface Props {
  className?: string;
}

export function HoppyGoLogo(props: Props) {
  return (
    <div className={cn(styles.logo, props.className)}>
      <svg fill="none" viewBox="0 0 600 160.96" xmlns="http://www.w3.org/2000/svg">
        <path
          className="fill-primary"
          d="m90.75,154.3c-3.81-20.14-4.91-55.4-5.21-69.98l-9.82,2.05c-.12,3.09-.36,7.5-.87,12.24-2.03,18.84-6.29,23.56-7.69,25.11-4.9,5.43-11.68,8.19-18.48,8.19-5.93,0-11.87-2.1-16.62-6.35-10.18-9.14-11.01-24.84-1.84-35,3.76-4.17,11.44-7.67,23.48-10.72,4.38-1.11,8.46-1.93,11.41-2.47.24-11.91.61-45.28-2.22-69.87l-.61-5.55C26.64,9.91,0,41.62,0,79.57c0,2.83.15,5.62.44,8.37,1.79,18.28,9.79,35.24,22.99,48.4,15.07,15.03,35.11,23.3,56.42,23.3,3.96,0,7.87-.29,11.72-.85l-.82-4.49Z"
        />
        <path
          className="fill-primary"
          d="m56.27,90.29c-9.17,2.33-15.91,5.12-18.03,7.47-5.19,5.75-4.72,14.63,1.04,19.81,5.76,5.17,14.67,4.71,19.86-1.04.78-.86,3.43-4.77,4.97-18.97.35-3.23.56-6.32.7-8.9h-.04s0-.26,0-.26c-2.47.49-5.44,1.12-8.52,1.91Z"
        />
        <path
          className="fill-primary"
          d="m121.84,61.38c4.9-5.67,4.25-14.26-1.44-19.14-2.56-2.2-5.72-3.28-8.87-3.28-3.83,0-7.64,1.6-10.33,4.71h0c-.73.85-3.22,4.7-4.41,18.56-.27,3.2-.42,6.27-.49,8.81,2.38-.52,5.22-1.2,8.16-2.02,13.16-3.65,16.63-6.77,17.38-7.64Z"
        />
        <path
          className="fill-primary"
          d="m159.18,71.57c-.05-.54-.13-1.07-.2-1.6-.08-.62-.14-1.24-.24-1.85C153.18,29.6,119.96,0,79.79,0c-2.32,0-4.61.12-6.88.31l.7,5.96c2.77,24.11,2.58,55.4,2.33,69.06l9.52-1.99c.05-3.02.19-7.31.58-11.93,1.57-18.48,5.65-23.21,6.99-24.76,4.25-4.93,10.17-7.91,16.67-8.39,6.5-.49,12.8,1.58,17.74,5.82,10.2,8.75,11.35,24.15,2.58,34.32-3.6,4.17-11.04,7.77-22.76,11.02-4.2,1.16-8.12,2.05-10.98,2.64.24,12.74,1.26,50.15,5.06,70.25l.83,4.17c12.75-3.69,24.44-10.52,34.09-20.14,15.07-15.03,23.37-35.01,23.37-56.26,0-2.86-.16-5.7-.46-8.5Z"
        />
        <path
          className="fill-primary"
          d="m245.84,20.57v59.9h-12.24v-24.81h-26.61v24.81h-12.24V20.57h12.24v23.45h26.61v-23.45h12.24Z"
        />
        <path
          className="fill-primary"
          d="m305.14,56.94c0,14.21-10.78,24.56-24.56,24.56s-24.47-10.44-24.47-24.56,10.95-24.56,24.47-24.56,24.56,10.35,24.56,24.56Zm-36.71,0c0,7.79,5.31,12.92,12.15,12.92s12.15-5.13,12.15-12.92-5.31-12.92-12.15-12.92-12.15,5.22-12.15,12.92Z"
        />
        <path
          className="fill-primary"
          d="m362.73,56.94c0,14.46-9.24,24.56-21.48,24.56-6.67,0-11.55-2.91-14.89-7.36v27.72h-12.24V33.41h12.24v6.59c3.25-4.54,8.3-7.62,14.89-7.62,12.07,0,21.48,10.01,21.48,24.56Zm-12.41,0c0-7.7-5.05-12.92-11.89-12.92s-12.07,5.22-12.07,12.92,5.22,12.92,12.07,12.92,11.89-5.13,11.89-12.92Z"
        />
        <path
          className="fill-primary"
          d="m420.31,56.94c0,14.46-9.24,24.56-21.48,24.56-6.67,0-11.55-2.91-14.89-7.36v27.72h-12.24V33.41h12.24v6.59c3.25-4.54,8.3-7.62,14.89-7.62,12.07,0,21.48,10.01,21.48,24.56Zm-12.41,0c0-7.7-5.05-12.92-11.89-12.92s-12.07,5.22-12.07,12.92,5.22,12.92,12.07,12.92,11.89-5.13,11.89-12.92Z"
        />
        <path
          className="fill-primary"
          d="m474.99,33.41l-30.63,68.45h-13.01l12.32-27.64-18.14-40.82h13.01l11.64,27.55,11.72-27.55h13.09Z"
        />
        <path
          className="fill-primary"
          d="m541.13,47.95v32.52h-10.44v-10.1c-2.74,6.42-10.1,11.12-20.19,11.12-16.69,0-29.78-12.92-29.78-30.89s13.09-31.06,30.98-31.06c14.29,0,25.41,8.56,28.92,20.88h-13.09c-2.82-5.73-8.56-9.24-15.92-9.24-11.04,0-18.57,8.04-18.57,19.59,0,10.87,6.67,19.42,18.4,19.42,8.22,0,14.98-4.28,17.03-11.98h-20.11v-10.27h32.77Z"
        />
        <path
          className="fill-primary"
          d="m600,56.94c0,14.21-10.78,24.56-24.56,24.56s-24.47-10.44-24.47-24.56,10.95-24.56,24.47-24.56,24.56,10.35,24.56,24.56Zm-36.71,0c0,7.79,5.31,12.92,12.15,12.92s12.15-5.13,12.15-12.92-5.31-12.92-12.15-12.92-12.15,5.22-12.15,12.92Z"
        />
        <path
          className="fill-primary"
          d="m208.05,137.95c0,4.21-2.69,7.16-6.26,7.16-1.94,0-3.37-.85-4.34-2.14v1.84h-3.57v-19.2h3.57v7.4c.95-1.32,2.42-2.22,4.34-2.22,3.52,0,6.26,2.92,6.26,7.16Zm-3.62,0c0-2.24-1.47-3.76-3.46-3.76s-3.52,1.52-3.52,3.76,1.52,3.76,3.52,3.76,3.46-1.49,3.46-3.76Z"
        />
        <path
          className="fill-primary"
          d="m223.39,131.1l-8.93,19.95h-3.79l3.59-8.05-5.29-11.89h3.79l3.39,8.03,3.42-8.03h3.81Z"
        />
        <path
          className="fill-primary"
          d="m231.49,144.64l3.46-5.54h20.08c1.14,0,1.88-.74,1.88-1.88v-3.21h-17.26c-5.14,0-7.42-2.28-7.42-7.32v-2.18c0-3.76,2.23-6.03,5.74-6.03h.4v8.11c0,1.14.74,1.88,1.88,1.88h16.72c3.81,0,6.08,2.28,6.08,5.98v2.87c0,4.9-2.42,7.32-7.42,7.32h-24.14Zm120.33-5.64h15.53c2.57,0,4.2-1.58,4.2-4.06v-6.78c0-2.47-1.63-4.06-4.2-4.06h-15.53v14.89Zm-6.23,5.64v-26.16h21.91c6.53,0,10.29,3.76,10.29,9.99v6.18c0,6.23-3.76,9.99-10.29,9.99h-21.91Zm-30.2-5.64h13.11c2.37,0,3.91-1.48,3.91-3.81v-7.27c0-2.32-1.53-3.81-3.91-3.81h-13.11c-2.37,0-3.91,1.48-3.91,3.81v7.27c0,2.32,1.53,3.81,3.91,3.81Zm13.26,5.64h-13.4c-6.33,0-9.99-3.66-9.99-9.74v-6.68c0-6.08,3.66-9.74,9.99-9.74h13.4c6.33,0,9.99,3.66,9.99,9.74v6.68c0,6.08-3.66,9.74-9.99,9.74Zm51.7,0l14.69-26.16h8.66l14.69,26.16h-7.12l-2.52-4.5h-12.51l-3.36-5.34-5.54,9.84h-6.97Zm12.66-10.14h12.56l-6.28-11.13-6.28,11.13Zm-148.51-10.58l-3.56-5.44h21.52l-3.46,5.44h-14.49Zm25.41,20.72v-26.16h6.23v10.19h8.26l10.73-10.19h8.26l-13.65,13.01,13.9,13.16h-8.75l-10.73-10.34h-8.01v10.34h-6.23Z"
        />
      </svg>
    </div>
  );
}

export function HoppyGoLogoVertical(props: Props) {
  return (
    <div className={cn(styles.logo, props.className)}>
      <svg fill="none" viewBox="0 0 500.21 430.98" xmlns="http://www.w3.org/2000/svg">
        <path
          className="fill-primary"
          d="m267.2,235.63c-5.81-30.72-7.49-84.49-7.95-106.73l-14.97,3.12c-.18,4.72-.54,11.43-1.32,18.67-3.09,28.73-9.59,35.94-11.73,38.3-7.47,8.28-17.81,12.49-28.19,12.49-9.04,0-18.11-3.2-25.34-9.69-15.53-13.95-16.8-37.89-2.81-53.38,5.74-6.35,17.45-11.7,35.81-16.35,6.68-1.69,12.91-2.94,17.4-3.77.37-18.17.93-69.07-3.38-106.57l-.94-8.47c-54.36,12.14-94.99,60.52-94.99,118.39,0,4.31.23,8.57.67,12.77,2.73,27.89,14.93,53.75,35.06,73.82,22.99,22.92,53.55,35.55,86.05,35.55,6.04,0,12.01-.44,17.88-1.3l-1.25-6.84Z"
        />
        <path
          className="fill-primary"
          d="m214.61,138c-13.98,3.55-24.26,7.81-27.5,11.39-7.91,8.77-7.2,22.32,1.59,30.21,8.79,7.89,22.38,7.18,30.29-1.59,1.19-1.31,5.24-7.28,7.58-28.94.53-4.93.86-9.64,1.07-13.58h-.06s.01-.4.01-.4c-3.77.74-8.29,1.71-12.99,2.91Z"
        />
        <path
          className="fill-primary"
          d="m314.63,93.9c7.47-8.65,6.48-21.75-2.19-29.2-3.91-3.36-8.73-5-13.53-5-5.84,0-11.65,2.44-15.75,7.19h0c-1.12,1.3-4.91,7.17-6.73,28.31-.42,4.88-.64,9.56-.75,13.44,3.62-.8,7.95-1.83,12.44-3.08,20.07-5.57,25.36-10.33,26.51-11.66Z"
        />
        <path
          className="fill-primary"
          d="m371.57,109.44c-.08-.82-.2-1.63-.3-2.45-.12-.94-.22-1.88-.36-2.82C362.42,45.43,311.75.28,250.48.28c-3.54,0-7.03.18-10.49.48l1.06,9.09c4.22,36.77,3.94,84.5,3.56,105.34l14.52-3.03c.07-4.61.28-11.15.88-18.2,2.4-28.19,8.62-35.4,10.66-37.77,6.48-7.51,15.52-12.06,25.43-12.8,9.91-.74,19.52,2.41,27.06,8.88,15.56,13.35,17.32,36.83,3.93,52.34-5.49,6.36-16.84,11.86-34.71,16.8-6.4,1.77-12.39,3.12-16.75,4.03.37,19.43,1.92,76.5,7.72,107.15l1.26,6.36c19.45-5.62,37.28-16.05,51.99-30.73,22.99-22.92,35.65-53.4,35.65-85.81,0-4.37-.25-8.69-.7-12.97Z"
        />
        <path
          className="fill-primary"
          d="m63.03,270.17v73.9h-15.1v-30.62H15.1v30.62H0v-73.9h15.1v28.93h32.84v-28.93h15.1Z"
        />
        <path
          className="fill-primary"
          d="m136.19,315.04c0,17.53-13.3,30.3-30.3,30.3s-30.19-12.88-30.19-30.3,13.51-30.3,30.19-30.3,30.3,12.77,30.3,30.3Zm-45.29,0c0,9.61,6.55,15.94,14.99,15.94s14.99-6.34,14.99-15.94-6.55-15.94-14.99-15.94-14.99,6.44-14.99,15.94Z"
        />
        <path
          className="fill-primary"
          d="m207.24,315.04c0,17.84-11.4,30.3-26.5,30.3-8.24,0-14.25-3.59-18.37-9.08v34.21h-15.1v-84.46h15.1v8.13c4.01-5.6,10.24-9.4,18.37-9.4,14.89,0,26.5,12.35,26.5,30.3Zm-15.31,0c0-9.5-6.23-15.94-14.68-15.94s-14.89,6.44-14.89,15.94,6.44,15.94,14.89,15.94,14.68-6.34,14.68-15.94Z"
        />
        <path
          className="fill-primary"
          d="m278.29,315.04c0,17.84-11.4,30.3-26.5,30.3-8.24,0-14.25-3.59-18.37-9.08v34.21h-15.1v-84.46h15.1v8.13c4.01-5.6,10.24-9.4,18.37-9.4,14.89,0,26.5,12.35,26.5,30.3Zm-15.31,0c0-9.5-6.23-15.94-14.68-15.94s-14.89,6.44-14.89,15.94,6.44,15.94,14.89,15.94,14.68-6.34,14.68-15.94Z"
        />
        <path
          className="fill-primary"
          d="m345.75,286.01l-37.8,84.46h-16.05l15.2-34.1-22.38-50.36h16.05l14.36,34,14.46-34h16.15Z"
        />
        <path
          className="fill-primary"
          d="m427.36,303.95v40.12h-12.88v-12.46c-3.38,7.92-12.46,13.73-24.92,13.73-20.59,0-36.74-15.94-36.74-38.11s16.15-38.32,38.22-38.32c17.63,0,31.36,10.56,35.69,25.76h-16.15c-3.48-7.07-10.56-11.4-19.64-11.4-13.62,0-22.91,9.92-22.91,24.18,0,13.41,8.24,23.97,22.7,23.97,10.14,0,18.48-5.28,21.01-14.78h-24.81v-12.67h40.44Z"
        />
        <path
          className="fill-primary"
          d="m500,315.04c0,17.53-13.3,30.3-30.3,30.3s-30.19-12.88-30.19-30.3,13.51-30.3,30.19-30.3,30.3,12.77,30.3,30.3Zm-45.29,0c0,9.61,6.55,15.94,14.99,15.94s14.99-6.34,14.99-15.94-6.55-15.94-14.99-15.94-14.99,6.44-14.99,15.94Z"
        />
        <path
          className="fill-primary"
          d="m119.86,414.83c0,5.2-3.32,8.83-7.72,8.83-2.4,0-4.15-1.05-5.35-2.65v2.28h-4.4v-23.69h4.4v9.14c1.17-1.63,2.98-2.74,5.35-2.74,4.34,0,7.72,3.6,7.72,8.83Zm-4.46,0c0-2.77-1.81-4.64-4.28-4.64s-4.34,1.88-4.34,4.64,1.88,4.64,4.34,4.64,4.28-1.84,4.28-4.64Z"
        />
        <path
          className="fill-primary"
          d="m138.78,406.37l-11.01,24.61h-4.68l4.43-9.94-6.52-14.67h4.68l4.18,9.91,4.21-9.91h4.71Z"
        />
        <path
          className="fill-primary"
          d="m148.77,423.08l4.27-6.83h24.78c1.4,0,2.32-.92,2.32-2.32v-3.97h-21.3c-6.35,0-9.15-2.81-9.15-9.03v-2.69c0-4.64,2.75-7.45,7.08-7.45h.49v10.01c0,1.4.92,2.32,2.32,2.32h20.63c4.7,0,7.51,2.81,7.51,7.38v3.54c0,6.04-2.99,9.03-9.15,9.03h-29.78Zm148.47-6.96h19.16c3.17,0,5.19-1.95,5.19-5v-8.36c0-3.05-2.01-5-5.19-5h-19.16v18.37Zm-7.69,6.96v-32.28h27.03c8.06,0,12.69,4.64,12.69,12.33v7.63c0,7.69-4.64,12.33-12.69,12.33h-27.03Zm-37.26-6.96h16.17c2.93,0,4.82-1.83,4.82-4.7v-8.97c0-2.87-1.89-4.7-4.82-4.7h-16.17c-2.93,0-4.82,1.83-4.82,4.7v8.97c0,2.87,1.89,4.7,4.82,4.7Zm16.35,6.96h-16.54c-7.81,0-12.33-4.52-12.33-12.02v-8.24c0-7.51,4.52-12.02,12.33-12.02h16.54c7.81,0,12.33,4.52,12.33,12.02v8.24c0,7.51-4.52,12.02-12.33,12.02Zm63.79,0l18.12-32.28h10.68l18.12,32.28h-8.79l-3.11-5.55h-15.44l-4.15-6.59-6.83,12.14h-8.6Zm15.62-12.51h15.5l-7.75-13.73-7.75,13.73Zm-183.23-13.06l-4.39-6.71h26.55l-4.27,6.71h-17.88Zm31.35,25.57v-32.28h7.69v12.57h10.19l13.24-12.57h10.19l-16.84,16.05,17.15,16.23h-10.8l-13.24-12.75h-9.89v12.75h-7.69Z"
        />
      </svg>
    </div>
  );
}
